/**
matchHeight makes the height of all selected elements exactly equal.
*/

import $ from 'jquery';
require('jquery-match-height');

// Module events
export default function init() {
	
	// Add matching height per row
	$('.js-match-height').matchHeight();
	
	// Add matching height to all elements on page
	$('.js-match-height-all').matchHeight({
		byRow: false
	});

}